import { Card, CardBody, Col } from "reactstrap";
import CommonFileUpload from "../../../../CommonElements/CommonFileUpload";
import { fileUploadData } from "../../../../Data/BonusUi/Dropzone/Dropzone";
import { MultiFileUploads } from "../../../../utils/Constant";
import CardHeaderCommon from "../../CardHeaderCommon/CardHeaderCommon";

const MultiFileUpload = () => {
  return (
    <Col lg="6">
      <Card>
        <CardHeaderCommon title={MultiFileUploads} span={fileUploadData} />
        <CardBody>
          <CommonFileUpload multiple />
        </CardBody>
      </Card>
    </Col>
  );
};

export default MultiFileUpload;
